import styled from 'styled-components';

export const StyledEmptyContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.light};
  padding-top: 4.6rem;
  padding-bottom: 4.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border.main};
`;

export const StyledHeading = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.text.main};
  text-align: center;
`;

export const StyledDescription = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
`;
